import { createContext, useContext, useState } from "react";

export const GraduationContext = createContext([]);

export const GraduationProvider = ({ children }) => {
  const [graduationDrink, setGraduationDrink] = useState([]);

  const localHousing = () =>
    localStorage.setItem("graduationDrink", JSON.stringify(graduationDrink));

  const addDrinkGraduation = (beer) => {
    setGraduationDrink([...graduationDrink, beer]);
    localHousing();
  };

  const removeDrinkGraduation = (beer) => {
    const removeDrink = graduationDrink.findIndex(
      (drink) => drink.name === beer.name
    );
    const updateGraduationDrink = graduationDrink.filter(
      (drink, index) => index !== removeDrink
    );
    setGraduationDrink(updateGraduationDrink);
    localHousing();
  };

  return (
    <GraduationContext.Provider
      value={{
        graduationDrink,
        setGraduationDrink,
        addDrinkGraduation,
        removeDrinkGraduation,
        localHousing
      }}
    >
      {children}
    </GraduationContext.Provider>
  );
};

export const useGraduationDrink = () => useContext(GraduationContext);
